const initialState = {
    categories : null,
    categoryFilter: {code:'attachments'},
    applicationFilter: null,
    machineFilter: null,
    machineAccessories : null,
    results:[],
    total:0,
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setCategories(state, value) {
            state.categories = value;
        },
        setCategoryFilter(state, value) {
            state.categoryFilter = value;
        },
        setApplicationFilter(state, value) {
            state.applicationFilter = value;
        },
        setMachineFilter(state, value) {
            state.machineFilter = value;
        },
        setTotal(state, value) {
            state.total = value;
        },
        setResults(state, value) {
            state.results = value;
        },
        setMachineAccessories(state, value) {
            state.machineAccessories = value;
        },
    },
};
